import { render, staticRenderFns } from "./addYield.vue?vue&type=template&id=05070062&scoped=true&"
import script from "./addYield.vue?vue&type=script&lang=js&"
export * from "./addYield.vue?vue&type=script&lang=js&"
import style0 from "./addYield.vue?vue&type=style&index=0&id=05070062&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05070062",
  null
  
)

export default component.exports